import styled from 'styled-components'

export interface StyledSearchableProps {
  $disabled?: boolean
  $hasSelection?: boolean
}

export const StyledSearchable = styled.div<StyledSearchableProps>`
  ${({ theme, $disabled, $hasSelection }) => `
      pointer-events: ${$disabled ? 'none' : 'auto'};
      width: 100%;
      text-align: left;
      color: ${theme.colors.black};
      margin-right: ${theme.sizes[6]};
      display: flex;
      align-items: center;

      label {
        display: flex;
      }
      input {
        pointer-events: ${$disabled ? 'none' : 'auto'};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        min-width: 0;

        ::placeholder {
          font-size: ${theme.fontSizes.bodySmall};
          font-weight: ${theme.fontWeights.regular};
          line-height: ${theme.sizes[5]};
          color: ${
            $hasSelection ? theme.colors.black : theme.colors.neutral300
          };
          opacity: 1;
        }
      }
    `}
`
